import { SET_SHOW_MOBILE_SEARCH } from "constants-lib/actionTypes"

export const setShowMobileSearch = (showMobileSearch, isSupportSearch) => ({
  type: SET_SHOW_MOBILE_SEARCH,
  payload: {
    showMobileSearch,
    isSupportSearch,
  },
})
